import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';

import PlatterGraphicSvg from 'eventbrite_design_system/iconography/icons/PlatterGraphic';
import ChangesGraphicSvg from 'eventbrite_design_system/iconography/icons/ChangesGraphic';
import CopyGraphicSvg from 'eventbrite_design_system/iconography/icons/CopyGraphic';

export default {
    packageSelectionPrompt: {
        heading: lazyGettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: lazyGettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: lazyGettext('Select Package'),
        graphic: <PlatterGraphicSvg />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    nonAdminPrompt: {
        heading: lazyGettext('Create with Eventbrite Professional'),
        secondaryHeading: lazyGettext(
            'In order to create an event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: lazyGettext('Create Event'),
        graphic: <ChangesGraphicSvg />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
    copyPackageSelectionPrompt: {
        heading: lazyGettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: lazyGettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: lazyGettext('Select Package'),
        graphic: <PlatterGraphicSvg />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    copyNonAdminPrompt: {
        heading: lazyGettext('Copy with Eventbrite Professional'),
        secondaryHeading: lazyGettext(
            'In order to copy this event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: lazyGettext('Copy Event'),
        graphic: <CopyGraphicSvg />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
};
